import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';
import { defineCustomElement as defineFallbackFooter } from '@now/dpl-webcomponents/dist/components/now-fallback-footer';
import { LIB_CONFIG } from '../../../lib.config';

defineFallbackFooter();

@Component({
  selector: 'now-wbsuche-lib-footer',
  templateUrl: './footer.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FooterComponent {
  public nowPortalBasePath = inject(LIB_CONFIG).nowPortalBasePath;
}
